import Footer from "./Footer"
import { Outlet } from "react-router-dom"
import React from 'react'

function Layout(props) {
  return (
    <>
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}

export default Layout
